/* MC custom JS */

$(document).ready(function () {

  setTimeout(() => {
    //add class when Shop by Occasion menu is active
    if($('[data-header] .shop-by-occasion .c-desktop-menu__item-link').hasClass('is-active')){
      $('body').addClass('shop-by-occasion-active');
    }

    //for Personalised Cooler template
    if ($('.product-collection__custom-cooler form[data-product-handle="cooler-20-litre"]').length) {
     $(`.product-collection__custom-cooler [data-product-builder-template][title="Custom Cooler 20L"]`).trigger('click');
    }
  },500);
  
  window.dispatchEvent(new Event('resize'));
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 1000);
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 3000);

  if ($('body').hasClass('c-page--product')) {
    //console.log('grdg');
    $(document).find('button[data-select-color-step]').on('click', function () {
      $('.c-product-carousel-thumbs .c-product-carousel-thumbs-item[data-thumbs-reference="1"]').trigger('click');
      $(document).find('textarea[data-product-builder-text]').trigger('keyup');
    });
  }

  $('.smooth-scroll').on('click', function (evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top }, 1000);
  });
  
  (function () {
    // Grab All Selectes, that used for redirect
    var $redirectSelect = $('[data-page-redirect]');

    if ($redirectSelect.length === 0) return;

    // Make Selected first option. On "history back", not first, but
    // clicked option is displayed. Script fixes it.
    $redirectSelect[0].selectedIndex = 0;
    window.addEventListener('pageshow', (event) => {
      $redirectSelect[0].selectedIndex = 0;
    });

    // Cause redirect based on the option's value
    $redirectSelect.on('change', function () {
      var redirectTo = $(this)[0].value;
      if (redirectTo === '#') return;

      if (window.redirect !== '/') redirectTo = redirectTo.replace(window.routes.domain, window.redirect);

      window.location.href = redirectTo;
    });
  })();

  // Steps mobile slider
  (function () {
    var $slider = $('.c-how-it-works__steps-box'),
      options = {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1.3,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33px" height="27px" viewBox="0 0 33 27" class="o-icon o-icon--arrow-right-red-mobile o-btn--with-arrow cust-svg-130601"><g id="Templates--inject-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="BEYSIS_M-Home--inject-1" transform="translate(-146.000000, -4513.000000)" fill="#B96955" fill-rule="nonzero" stroke="#B96955"><g id="noun_Arrow_1434313-Copy-3--inject-1" transform="translate(163.000000, 4526.500000) rotate(-90.000000) translate(-163.000000, -4526.500000) translate(150.000000, 4510.000000)"><polygon id="Path--inject-1" points="12.5234375 0.5 12.5117188 30.572591 1.18359375 18.8486719 0.5 19.5561498 12.9465812 32.5 25.5 19.5561498 24.8164062 18.8486719 13.4882812 30.572591 13.5 0.5"></polygon></g></g></g></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33px" height="27px" viewBox="0 0 33 27" class="o-icon o-icon--arrow-right-red-mobile o-btn--with-arrow cust-svg-130601"><g id="Templates--inject-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="BEYSIS_M-Home--inject-1" transform="translate(-146.000000, -4513.000000)" fill="#B96955" fill-rule="nonzero" stroke="#B96955"><g id="noun_Arrow_1434313-Copy-3--inject-1" transform="translate(163.000000, 4526.500000) rotate(-90.000000) translate(-163.000000, -4526.500000) translate(150.000000, 4510.000000)"><polygon id="Path--inject-1" points="12.5234375 0.5 12.5117188 30.572591 1.18359375 18.8486719 0.5 19.5561498 12.9465812 32.5 25.5 19.5561498 24.8164062 18.8486719 13.4882812 30.572591 13.5 0.5"></polygon></g></g></g></svg></button>',
      }
    function sliderHandle() {
      if (window.innerWidth <= 992) {
        $slider.slick(options);
      } else if (window.innerWidth > 992 && $slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }

    if ($slider.length === 0) return;

    sliderHandle();
    window.addEventListener('resize', sliderHandle);
  })();

  // Corporate page mobile slider
  (function () {
    var $sliderDom = $('.c-corporate__slider'),
      btn = document.querySelector('[data-slider-next]'),
      options = {
        dots: false,
        arrows: false,
        infinite: false,
      }
    function sliderHandle() {
      if (window.innerWidth <= 750) {
        $sliderDom.slick(options);
      } else if (window.innerWidth > 750 && $sliderDom.hasClass('slick-initialized')) {
        $sliderDom.slick('unslick');
      }
    }

    if ($sliderDom.length === 0) return;

    sliderHandle();
    window.addEventListener('resize', sliderHandle);

    btn.addEventListener('click', function () {
      $sliderDom.slick('slickNext');
    });

    $sliderDom.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      (slick.slideCount - 1) === nextSlide
        ? btn.style.opacity = '0'
        : btn.removeAttribute('style');
    });
  })();

  // Adjust links url
  const adjustLinksFunction = () => {
    const linksToAdjust = document.querySelectorAll('[data-adjust-link-url] a');
    linksToAdjust.forEach(link => {
      let href = link.getAttribute('href');
      // Case of relative link
      if (href.charAt(0) === '/') {
        link.setAttribute('href', `${window.routes.root + href}`)
      } else if (href.includes(window.routes.domain)) {
        if (window.routes.root === '/') return;
        let formatedHref = href.replace(window.routes.domain, window.routes.root);
        link.setAttribute('href', formatedHref);
      }
    })
  }
  adjustLinksFunction();
  window.adjustLinksFunction = adjustLinksFunction;

  // Slide out cart API
  window.SLIDECART_LOADED = function () {
    // Parse cart title
    (() => {
      let title = document.querySelector('#slidecarthq .header h2');
      if (!title) return;

      title.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 27" width="22"><path fill="#B96955" fill-rule="nonzero" stroke="#B96955" d="m1 13.9765625 30.072591.0117187-11.7239191 11.32812505L20.0561498 26 33 13.5534188 20.0561498 1l-.7074779.6835938 11.7239191 11.328125L1 13z" style="transform: rotate(180deg);transform-origin: center center; "></path></svg>
        ${title.innerHTML}  
      `;

      title.addEventListener('click', () => {
        window.location.href = `${window.routes.collections_all}`;
      });
    })();

    // If was cart - open slide out cart on redirect
    (() => {
      if (sessionStorage.getItem('open_cart_on_load') !== 'true') return;
      window.SLIDECART_OPEN();
      sessionStorage.removeItem('open_cart_on_load');
    })();
  }
  
  window.SLIDECART_UPDATED = function (cart) {
    document.querySelector('[data-cart-counter]').innerHTML = `<span>${cart.item_count}</span>`;

    // cart not text edit
    (() => {
      let noteTrigger = document.querySelector('#slidecarthq .note-trigger');
      if (!noteTrigger) return;
      let noteText = noteTrigger.textContent;
      let svgToInclude = `<svg fill="#000000" height="14px" width="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><g><g><path d="M502.724,73.422L438.577,9.275c-12.367-12.367-32.49-12.367-44.857,0L53.087,349.907 c-1.091,1.091-1.921,2.416-2.425,3.875l-50.1,144.68c-1.278,3.691-0.336,7.788,2.425,10.55C4.932,510.957,7.539,512,10.201,512 c1.118,0,2.245-0.184,3.336-0.562l144.681-50.1c1.459-0.505,2.783-1.335,3.875-2.425l340.631-340.631 C515.091,105.913,515.091,85.79,502.724,73.422z M26.711,485.288l12.364-35.705l23.342,23.342L26.711,485.288z M83.846,465.504 l-37.351-37.35l18.609-53.739l72.481,72.481L83.846,465.504z M155.848,436.308l-50.783-50.783l125.381-125.381 c3.983-3.983,3.983-10.441,0-14.425c-3.983-3.982-10.441-3.982-14.425,0L90.641,371.101l-14.948-14.948L358.089,73.755 l40.078,40.078l40.078,40.078L155.848,436.308z M488.299,103.856l-35.63,35.63L372.513,59.33l35.63-35.631 c4.414-4.414,11.597-4.414,16.01,0l64.147,64.147C492.714,92.259,492.714,99.443,488.299,103.856z"></path> </g> </g> <g> <g> <path d="M268.693,207.472c-3.982-3.982-10.44-3.982-14.424,0l-14.279,14.279c-3.983,3.983-3.983,10.441,0,14.425 c1.992,1.991,4.602,2.987,7.212,2.987c2.61,0,5.221-0.996,7.212-2.987l14.279-14.279 C272.676,217.914,272.676,211.456,268.693,207.472z"></path></g></g></g></svg>`;
      noteTrigger.innerHTML = `${svgToInclude}<span>${noteText}</span>`;
    })();

    document.querySelectorAll('#slidecarthq .item').forEach(item => {
      // Get subheading
      let productTitle = item.querySelector('.title a'),
        parseURL = productTitle.getAttribute('href').split('?')[0] + '?view=do-not-use-heading-metafield-js';
      fetch(parseURL)
        .then(response => response.json())
        .then(data => {
          if (!data || !data.title || !data.subheading)
            console.log('No data')
          else
            productTitle.innerHTML = `
              <span>${data.title}</span>
              <br>
              <small>${data.subheading}</small>
            `
        });

      // Round pricing
      let price = item.querySelector('.price'),
        priceHTML = price.innerHTML;
      if (priceHTML.slice(priceHTML.length - 3) === '.00' || priceHTML.slice(priceHTML.length - 3) === ',00') {
        price.innerHTML = priceHTML.slice(0, priceHTML.length - 3);
      }
    });

    // Init accordions
    (() => {
      const accordions = document.querySelectorAll('[data-cart-accordion]');

      accordions.forEach(accordion => {
        let trigger = accordion.querySelector('[data-cart-accordion-toggle]');

        let isInited = trigger.classList.contains('inited');
        if (isInited) return;
        trigger.classList.add('inited');

        trigger.addEventListener('click', () => {
          trigger.parentElement.classList.toggle('expand');
        })
      });

      window.adjustLinksFunction();
    })();
    
  }


  if(window.REELUP?.stories){
    $('.reelUp_stories_widget_wrap').removeClass('hidden');
  }
  
  
  // setTimeout(function(){
  // $(".upsell-options .button").click(function(){
  //   var getPrice = $('.upsell-options-prices p').text().replace(/[^\d.]/g, '');
  //   fbq('track', 'AddToCart');
  //   ttq.track('AddToCart');
  //    pintrk('track', 'addtocart', {
  //      value: getPrice,
  //      order_quantity: 1,
  //      currency: 'AUD'
  //    });
  // });
  //   $(".upsells-stacked .upsell").each(function(){
  //    if ($(this).hasClass('multi')){
  //    }
  //     else{
  //      $(this).addClass("without_option");
  //     }
  //   });
  //   $(".without_option").find(".upsell-add button").click(function(){
  //     var getPrice = $(".without_option").find('.upsell-text-prices p').text().replace(/[^\d.]/g, '');
  //     fbq('track', 'AddToCart');
  //     ttq.track('AddToCart');
  //      pintrk('track', 'addtocart', {
  //        value: getPrice,
  //        order_quantity: 1,
  //        currency: 'AUD'
  //      });
  //   });
      
  // },2000);


  setTimeout(function(){
    
    $(".c-product-builder__templates-icon").each(function(){
      if ($(this).hasClass("is-selected")) {
        
        //for notebook collection
        if ($(this).attr('title') == 'Notebook - Bottom right' ) {
           $(".product-collection__personalised-notebook .c-product-builder-carousel__template").addClass("botttom_layout");
        } else {
          $(".product-collection__personalised-notebook .c-product-builder-carousel__template").removeClass("botttom_layout");
        }
        
        //for passport template
        if ($(this).attr('title') == 'Passport - Bottom right') {
          $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_center_layout");
          $(".product-collection__personalised-passport .c-product-builder-carousel__template").addClass("botttom_right_layout");
        } else if($(this).attr('title') == 'Passport - Bottom center'){
          $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_right_layout");
          $(".product-collection__personalised-passport .c-product-builder-carousel__template").addClass("botttom_center_layout");
        } else {
          $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_right_layout botttom_center_layout");
        }

        //for card holder template
        if ($(this).attr('title') == 'Card - Bottom right') {
          $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_center_layout");
          $(".product-collection__card-holder .c-product-builder-carousel__template").addClass("botttom_right_layout");
        } else if($(this).attr('title') == 'Card - Bottom center'){
          $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_right_layout");
          $(".product-collection__card-holder .c-product-builder-carousel__template").addClass("botttom_center_layout");
        } else {
          $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_right_layout botttom_center_layout");
        }

        //for wine cooler template
        if ($(this).attr('title') == 'Wine Cooler - Horizontal Bottom Center') {
           $(".product-collection__wine-cooler .c-product-builder-carousel__template").addClass("wine_coller_botttom_layout");
        } else {
          $(".product-collection__wine-cooler .c-product-builder-carousel__template").removeClass("wine_coller_botttom_layout");
        }
        
      } 
    });
    
    $(".c-product-builder__templates").find(".c-product-builder__templates-icon").click(function(){
      var getcurrnt = $(this).attr('title');
      console.log("getcurrnt",getcurrnt);

      //for notebook collection
      if (getcurrnt == 'Notebook - Bottom right') {
        $(".product-collection__personalised-notebook .c-product-builder-carousel__template").addClass("botttom_layout");
      }else{
        $(".product-collection__personalised-notebook .c-product-builder-carousel__template").removeClass("botttom_layout");
      }

      //for passport template
      if (getcurrnt == 'Passport - Bottom right') {
        $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_center_layout");
        $(".product-collection__personalised-passport .c-product-builder-carousel__template").addClass("botttom_right_layout");
      }else if($(this).attr('title') == 'Passport - Bottom center'){
        $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_right_layout");
        $(".product-collection__personalised-passport .c-product-builder-carousel__template").addClass("botttom_center_layout");
      } else{
        $(".product-collection__personalised-passport .c-product-builder-carousel__template").removeClass("botttom_right_layout botttom_center_layout");
      }

      //for card holder template
      if (getcurrnt == 'Card - Bottom right') {
        $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_center_layout");
        $(".product-collection__card-holder .c-product-builder-carousel__template").addClass("botttom_right_layout");
      }else if($(this).attr('title') == 'Card - Bottom center'){
        $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_right_layout");
        $(".product-collection__card-holder .c-product-builder-carousel__template").addClass("botttom_center_layout");
      } else{
        $(".product-collection__card-holder .c-product-builder-carousel__template").removeClass("botttom_right_layout botttom_center_layout");
      }

      //for wine cooler template
      if ($(this).attr('title') == 'Wine Cooler - Horizontal Bottom Center' ) {
         $(".product-collection__wine-cooler .c-product-builder-carousel__template").addClass("wine_coller_botttom_layout");
      } else {
        $(".product-collection__wine-cooler .c-product-builder-carousel__template").removeClass("wine_coller_botttom_layout");
      }
      
    });

    
    //add class when Shop by Occasion menu is active
    if($('[data-header] .shop-by-occasion .c-desktop-menu__item-link').hasClass('is-active')){
      $('body').addClass('shop-by-occasion-active');
    }
    
  },1000);

  
});

// $(document).ready(function(){
//   $(".c-collection-template__products").find(".c-collection-template__product").each(function(){
//   $(this).find('.c-product-builder__swatches .color_swatches').each(function() {
//     $(this).click(function(e){
//      e.preventDefault();
//     $(this).addClass("is-selected").siblings().removeClass("is-selected");
//      var getVariantImage = $(this).attr('data-variant-image');
//     $(this).closest(".c-collection-template__product").find(".o-product-thumbnail__image-container").find("picture img, picture source").attr("srcset",getVariantImage);
//      console.log('getVariantImage', getVariantImage);
//     });
//    });
//   });
  
// })